var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm._url)?_c('video',{attrs:{"width":_vm.width,"height":_vm.height,"controls":_vm.controls,"autoplay":_vm.autoplay}},[_c('source',{attrs:{"src":_vm._url,"type":"video/mp4"}}),_c('source',{attrs:{"src":_vm._url,"type":"video/ogg"}}),_vm._v(" Your browser does not support the video tag. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }